export interface IProtectionPlanBusinessState {
    isLoading: boolean;
    protectionPlanData: IProtectionPlanResponse;
}

export const REQUEST_PROTECTION_PLAN_BUSINESS = "REQUEST_BUSINESS_PROTECTION_PLAN";
export const RECEIVE_PROTECTION_PLAN_BUSINESS = "RECEIVE_BUSINESS_PROTECTION_PLAN";

export interface IRequestProtectionPlanAction {
    type: typeof REQUEST_PROTECTION_PLAN_BUSINESS;
}

export interface IReceiveProtectionPlanAction {
    protectionPlanData: IProtectionPlanResponse;
    type: typeof RECEIVE_PROTECTION_PLAN_BUSINESS;
}

export interface IProduct {
    parent?: number;
    id: number;
    displayName?: string;
    description?: string;
    name: string;
    labelText: string;
    rowId?: number; // todo: maybe removed
    orderBy?: any;
    isAddOnService?: boolean;

    isChildProduct?: boolean;
    icon?: string;
    productDifferenceId?: number;
    IsHidden: boolean;
}

export interface IPackage {
    BasePackagePrice: number;
    BillingText: string;
    HasUserCancelled: boolean;
    IsActive: boolean;
    IsPacakgeUpgradable: boolean;
    IsPackageCancel: boolean;
    PackagId: number;
    PackageCode: string;
    CatalogPackageID: string;
    PackageName: string;
    PackagePrice: number;
    PackagePriceYearly: number;
    DisplayPrice?: boolean;
    SubcriptionType: string;
    PartnerId?: number;
    PartnerName?: string;
    PackageForCacellationContinuation?: boolean;
    Products?: IProduct[];
    ShowCrossOut?: boolean;
    YearlySavingPrice?: string;
    BasePackagePriceYearly?: number;
    IsPSS?: boolean;
    IsUserPaid?: boolean;

    FeatureID?: string;
    Featurevalue?: string;

    // Properties for UI logic
    DisplayPaymentInfo?: boolean;
    ShowSubscriptionTypeChangeText?: boolean;
    ActionButtonText?: string;
    ShowBillingText?: boolean;
    Price: number;
    ProductDifference?: IProduct[];
}

export interface ISmbLicenseLimit {
    key?: string;
    value?: string[];

    packageList?: IPackage[];
}

export type ProtectionPlanTypes = IRequestProtectionPlanAction | IReceiveProtectionPlanAction;

export interface IProtectionPlanResponse {
    packageList?: IPackage[];
    productList?: IProduct[];
    smbLicenseLimits?: ISmbLicenseLimit[];
    LicenseLimit?: string;
    ActiveAndPendingLicenseLimit?: string;
}
